import { Lock, Sparkles, MessageCircle, Check } from "lucide-react";
import { SUPPORT_WHATSAPP } from "../lib/constants";

export const LockedFeature = ({
  title = "هذه الميزة غير متاحة في باقتك الحالية",
  requiredPlan,
  currentPlan,
  supportWhatsapp,
}) => {
  const wa_num = supportWhatsapp || SUPPORT_WHATSAPP;
  const msg = requiredPlan
    ? `مرحباً، أرغب بترقية باقتي في WorkZone إلى باقة ${requiredPlan} لتفعيل هذه الميزة`
    : "مرحباً، أرغب بترقية باقتي في WorkZone لتفعيل ميزة إضافية";
  const wa = `https://wa.me/${wa_num}?text=${encodeURIComponent(msg)}`;
  return (
    <div data-testid="locked-feature" className="rounded-2xl border border-dashed border-amber-300 bg-gradient-to-b from-amber-50/70 to-white py-16 px-6 text-center">
      <div className="mx-auto h-14 w-14 rounded-2xl bg-amber-100 flex items-center justify-center mb-4">
        <Lock className="h-7 w-7 text-amber-600" />
      </div>
      <h3 className="font-heading text-xl font-bold text-slate-900">{title}</h3>
      {requiredPlan && (
        <div className="mt-3 inline-flex items-center gap-2 text-sm">
          {currentPlan && (
            <span className="rounded-full border border-slate-200 bg-slate-50 text-slate-500 px-3 py-1">
              باقتك: {currentPlan}
            </span>
          )}
          <span className="text-slate-300">←</span>
          <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 px-3 py-1 font-semibold">
            <Check className="h-3.5 w-3.5" /> متاحة في باقة {requiredPlan}
          </span>
        </div>
      )}
      <p className="mt-3 text-sm text-slate-500 max-w-md mx-auto">
        {requiredPlan
          ? `رقِّ اشتراكك إلى باقة «${requiredPlan}» للوصول إلى هذه الميزة وكامل مزاياها. الترقية فورية.`
          : "رقِّ باقتك للوصول إلى هذه الميزة وكامل مزايا WorkZone. تواصل معنا لترقية اشتراكك فوراً."}
      </p>
      <a href="/pricing" data-testid="locked-upgrade-cta"
        className="mt-5 inline-flex items-center gap-2 rounded-xl h-11 px-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold transition">
        <Sparkles className="h-4 w-4" /> عرض الباقات والترقية
      </a>
      <a href={wa} target="_blank" rel="noreferrer" className="mt-3 flex items-center justify-center gap-1.5 text-xs text-emerald-600">
        <MessageCircle className="h-3.5 w-3.5" /> أو تواصل عبر واتساب {wa_num}
      </a>
    </div>
  );
};
